import { EMPTY_ARRAY } from 'commons-ui';

export const actions = {
	bulkActions: EMPTY_ARRAY,
	rowActions: EMPTY_ARRAY,
	backAction: {
		name: 'Back',
		id: 'back'
	}
};

export default actions;
